// ==============================|| JOB ROLE TYPES  ||============================== //

import { CustomField, CustomFieldDto } from './customFields';
import { EmployeeMinDtoWithEmployment } from './employees';
import { EntityTextDto } from './jobPositions';
import { MinDto } from './other';

interface AuditFields {
    createdAt?: string;
    lastModifiedAt?: string;
    createdByEmployee?: MinDto;
    changedByEmployee?: MinDto;
}

export enum JobRoleGroupType {
    LEGAL = 'LEGAL',
    ADMIN = 'ADMIN',
}

export interface JobRolesListElement {
    id: number;
    name: string;
    internalName: string;
    abbreviation: string | null;
    orderNum: number | null;
    groupNameTypeCode: JobRoleGroupType;
    isActive: boolean;
    excludeFromMinmaxCalculation: boolean;
    isDraft?: boolean;
}

export interface JobRoleDetailsDto extends AuditFields {
    id: number;
    name: string;
    internalName: string;
    abbreviation: string | null;
    orderNum: number | null;
    groupNameTypeCode: JobRoleGroupType;
    entityTexts: EntityTextDto[] | null;
    isActive: boolean;
    excludeFromMinmaxCalculation: boolean;
    jobRoleEmployees: EmployeeMinDtoWithEmployment[];
    customFields?: CustomField[];
    isDraft?: boolean;
}

export interface JobRoleDto {
    id: number;
    name: string;
    internalName: string;
    abbreviation: string | null;
    orderNum: number | null;
    groupNameTypeCode: JobRoleGroupType;
    isActive: boolean;
    excludeFromMinmaxCalculation: boolean;
    // Set on a role deleted after a case priced it; such a row is read back but must not be written again.
    deletedAt?: string | null;
}

export interface JobRoleCreateDto {
    name: string;
    internalName: string;
    abbreviation: string | null;
    orderNum: number | null;
    groupNameTypeCode: JobRoleGroupType;
    entityTexts: EntityTextDto[] | null;
    isActive: boolean;
    excludeFromMinmaxCalculation: boolean;
    // Left out, an update keeps the stored values; sent, even empty, it replaces them.
    customFields?: CustomFieldDto[];
}

export interface JobRoleUpdateDto extends JobRoleCreateDto {
    id: string | number;
}
export interface JobRoleForm {
    name: string;
    internalName: string;
    abbreviation: string | null;
    orderNum: number | null;
    groupNameType: { label: string; value: JobRoleGroupType } | null;
    entityTexts: EntityTextDto[] | null;
    isActive: boolean;
    excludeFromMinmaxCalculation: boolean;
    jobRoleEmployees: MinDto[];
}
